import React, { FC, memo } from 'react';
import { useRadio, UseRadioProps, Flex } from '@chakra-ui/react';

interface I extends UseRadioProps {
  children: any;
}

const TipsRadioButtonComponent: FC<I> = ({ children, ...rest }) => {
  const { getInputProps, getCheckboxProps } = useRadio(rest);

  return (
    <Flex
      {...getCheckboxProps()}
      as="label"
      flex="1"
      sx={{
        '&:first-of-type': {
          borderLeftRadius: '4px',
        },
        '&:last-of-type': {
          borderRightRadius: '4px',
          borderRightWidth: '1px',
        },
      }}
      borderColor="currentColor"
      borderWidth="1px"
      borderStyle="solid"
      borderRightWidth="0"
      cursor="pointer"
      height="44px"
      justify="center"
      align="center"
      textStyle="p"
      data-testid="suggested-tip-amount"
      aria-hidden={false}
      _checked={{
        color: 'black',
        fontWeight: 600,
        borderColor: 'primary.350',
        borderWidth: '2px',

        '& + *': {
          borderLeftWidth: '0',
        },
      }}
      _focusWithin={{
        zIndex: 1,
        borderColor: 'primary.400',
        boxShadow: '0 0 0 1px var(--chakra-colors-primary-200)',
      }}
    >
      <input {...getInputProps()} />
      {children}
    </Flex>
  );
};

export const TipsRadioButton = memo(TipsRadioButtonComponent);
